import settings from '@nobia/zeus-components/lib/settings'
import styled, { theme } from '@nobia/zeus-components/lib/styled'
import { Image as CloudinaryImg, Placeholder } from 'cloudinary-react'
import PropTypes from 'prop-types'
import React from 'react'

const Img = styled(CloudinaryImg)`
  width: 100%;
  max-width: 100%;
  border-radius: ${theme('home.image.borderRadius')};
`

export const Image = ({ publicId, borderRadius, children, ...props }) => (
  <Img
    key={publicId}
    alt={
      publicId?.endsWith('/')
        ? publicId?.split('/')[-2]
        : publicId?.split('/')[-1]
    }
    cloudName={settings.cloudinary.cloudName}
    publicId={publicId}
    borderradius={borderRadius}
    loading="lazy"
    dpr="auto"
    width="600"
    crop="scale"
    responsiveUseBreakpoints="true"
    responsive
    {...props}
  >
    {children}
    <Placeholder type="pixelated" />
  </Img>
)

Image.defaultProps = {
  children: null,
  borderRadius: '',
}

Image.propTypes = {
  children: PropTypes.node,
  publicId: PropTypes.string.isRequired,
  borderRadius: PropTypes.string,
}

export default Image
